module.exports = __webpack_public_path__ + "static/icon-food-1fa28f2bcca0f0490976d2a9cc131204.svg";